import { matchPath, useLocation } from 'react-router-dom'

export function useRouteMatch(patterns: string[]) {
  const { pathname } = useLocation()

  return patterns
    .map((pattern) => matchPath(pattern, pathname))
    .find((result) => result !== null)
}
